// DataMeridian brand mark — uses the approved DM+compass PNG asset.
// On light surfaces (navbar) the mark is rendered inside a dark navy tile
// so the metallic silver reads clearly; on dark surfaces (footer) the mark
// sits directly on the background.

export function Logomark({ size = 44, className = "", surface = "light" }) {
  const isLight = surface === "light";
  const boxStyle = isLight
    ? {
        background: "var(--dm-navy)",
        padding: 6,
        borderRadius: 4,
        boxShadow: "0 1px 2px rgba(15,23,42,0.08)",
      }
    : { padding: 0 };
  const imgHeight = size;
  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", ...boxStyle }}
    >
      <img
        src="/brand/dm-mark.png"
        alt="DataMeridian mark"
        style={{ display: "block", height: imgHeight, width: "auto", objectFit: "contain" }}
      />
    </span>
  );
}

export function Wordmark({ tone = "dark", className = "" }) {
  const primary = tone === "dark" ? "text-[var(--dm-navy)]" : "text-white";
  const emeraldClass = "text-[var(--dm-emerald)]";
  const muted   = tone === "dark" ? "text-[var(--dm-muted)]" : "text-white/60";
  return (
    <span className={`leading-tight ${className}`}>
      <span className="block font-serif text-lg tracking-tight">
        <span className={primary}>Data</span>
        <span className={emeraldClass}>Meridian</span>
      </span>
      <span className={`block text-[10px] uppercase tracking-[0.42em] ${muted}`}>
        Consulting
      </span>
    </span>
  );
}

export default function Logo({ tone = "dark", size = 34, className = "", showWordmark = true }) {
  // tone "dark" = dark text on light surface (navbar); "light" = light text on dark surface (footer)
  const surface = tone === "dark" ? "light" : "dark";
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <Logomark size={size} surface={surface} />
      {showWordmark && <Wordmark tone={tone} />}
    </span>
  );
}
